import { DateTimePicker } from "@mui/lab";
import { TextField } from "@mui/material";
import { Dayjs } from "dayjs";
import React from "react";

interface DateTimeFieldProps {
  label: string;
  maxDateTime?: Dayjs;
  value: Dayjs;
  onChange: (value: Dayjs) => void;
}

export default function DateTimeField({
  label,
  value,
  onChange,
  maxDateTime,
}: DateTimeFieldProps) {
  return (
    <DateTimePicker
      maxDateTime={maxDateTime}
      value={value}
      label={label}
      onChange={onChange}
      renderInput={(params) => <TextField margin="dense" {...params} />}
    />
  );
}
